export default "__VITE_ASSET__Ssq_8ZuU__"